import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BackendAuthService {

  private token: string | null = null;
  private expiraEn: number | null = null;

  
  constructor(private http: HttpClient) { }

  async obtenerToken(): Promise<any> {
    const url = `${environment.backendUrl}/esi-token`;
    const body = {
      client_id: environment.clientId
    };

    return firstValueFrom(this.http.post(url, body));
  }
}
